import { Component, inject, ChangeDetectorRef, OnDestroy, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterOutlet, NavigationEnd } from '@angular/router';
import { SlideInRightModalComponent } from '@shared/ui/slide-in-right-modal/slide-in-right-modal.component';
import { ButtonDirective } from '@shared/directives/button.directive';
import { AccountManagementService } from '@core/services/account-management.service';
import { NotificationFacade } from '@core/facades/notification.facade';
import { Subscription, filter } from 'rxjs';

@Component({
  selector: 'app-create-minor-account',
  standalone: true,
  imports: [
    CommonModule,
    SlideInRightModalComponent,
    ButtonDirective,
    RouterOutlet,
  ],
  templateUrl: './create-minor-account.component.html',
  styleUrl: './create-minor-account.component.scss',
})
export class CreateMinorAccountComponent implements OnInit, OnDestroy {
  subs: Subscription[] = [];
  isLoading: boolean = false;
  accountId!: string;

  private activatedRoute = inject(ActivatedRoute);
  private router = inject(Router);
  toast = inject(NotificationFacade);
  change = inject(ChangeDetectorRef);
  accountService = inject(AccountManagementService);

  ngOnInit() {
    this.accountId = this.activatedRoute.snapshot.parent?.params['accountId'];
  }

  navigateToHasNIN() {
    this.router.navigate([`/admin/accounts/individual/accounts/${this.accountId}/nin-minor-account`]);
  }

  navigateToNoNIN() {

    this.router.navigate([`/admin/accounts/individual/accounts/${this.accountId}/no-nin-minor-account`]);
  }

  get returnPathUrl(): string {
    return `/admin/accounts/individual/accounts/${this.accountId}`;
  }

  closeModal(): void {
    history.back();
  }

  ngOnDestroy() {
    this.subs.forEach(sub => sub.unsubscribe());
  }
}